import React from 'react'
import "./portfolio.css"
import IMG1 from "../../assets/password.webp"
import IMG2 from "../../assets/NFT1.webp"
import IMG3 from "../../assets/soap.webp"
import IMG4 from "../../assets/travel.webp"
import IMG5 from "../../assets/sports-blog.webp"
import IMG6 from "../../assets/trivia.webp"
import IMG7 from "../../assets/chart.webp"


const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio_container">
      <article className="portfolio_item">
          <div className="portfolio_item-image">
            <img src={IMG5} alt="portfolio image" />
          </div>
          <h3>Sports Blog Using Graphql</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com/Cadensmith1123/Trail-blazer-corner" className='btn' target="_blank">Github</a>
          <a href="https://trail-blazers-corner-ldryafc4t-cadensmith1123.vercel.app/" className='btn btn-primary' target="_blank">Live Demo</a>
          </div>
        </article>

        <article className="portfolio_item">
          <div className="portfolio_item-image">
            <img src={IMG7} alt="portfolio image" />
          </div>
          <h3>CRUD Notes APP with Crypto Changes</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com/Cadensmith1123/chart-palooza" className='btn' target="_blank">Github</a>
          <a href="https://cadensmith1123.github.io/chart-palooza/" className='btn btn-primary' target="_blank">Live Demo</a>
          </div>
        </article>

        <article className="portfolio_item">
          <div className="portfolio_item-image">
            <img src={IMG3} alt="portfolio image" />
          </div>
          <h3>Mock E-Commerce Website</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com/Cadensmith1123/SilverCreekSoap" className='btn' target="_blank">Github</a>
          <a href="https://cadensmith1123.github.io/SilverCreekSoap/" className='btn btn-primary' target="_blank">Live Demo</a>
          </div>
        </article>
        <article className="portfolio_item">
          <div className="portfolio_item-image">
            <img src={IMG2} alt="portfolio image" />
          </div>
          <h3>SilverFalls NFT Test Minting Website</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com/Cadensmith1123/SilverFallsNFT1" className='btn' target="_blank">Github</a>
          <a href="https://cadensmith1123.github.io/SilverFallsNFT1/" className='btn btn-primary' target="_blank">Live Demo</a>
          </div>
        </article>
        <article className="portfolio_item">
          <div className="portfolio_item-image">
            <img src={IMG4} alt="portfolio image" />
          </div>
          <h3>Mock Silverton Travel Website</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com/Cadensmith1123/Silverton_Travel" className='btn' target="_blank">Github</a>
          <a href="https://cadensmith1123.github.io/Silverton_Travel/" className='btn btn-primary' target="_blank">Live Demo</a>
          </div>
        </article>
        <article className="portfolio_item">
          <div className="portfolio_item-image">
            <img src={IMG6} alt="portfolio image" />
          </div>
          <h3>NBA Trivia Game (Not supported on Mobile)</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com/Cadensmith1123/Basketball-Trivia" className='btn' target="_blank">Github</a>
          <a href="https://cadensmith1123.github.io/Basketball-Trivia/" className='btn btn-primary' target="_blank">Live Demo</a>
          </div>
        </article>
        <article className="portfolio_item">
          <div className="portfolio_item-image">
            <img src={IMG1} alt="portfolio image" />
          </div>
          <h3>Password Generatorinator</h3>
          <div className="portfolio_item-cta">
          <a href="https://github.com/Cadensmith1123/Password-Generatorinator" className='btn' target="_blank">Github</a>
          <a href="https://cadensmith1123.github.io/Password-Generatorinator/" className='btn btn-primary' target="_blank">Live Demo</a>
          </div>
        </article>
      
      </div>
    </section>
  )
}

export default Portfolio